import { render, staticRenderFns } from "./QueuesStatisticsSearch.vue?vue&type=template&id=2d217d6a"
import script from "./QueuesStatisticsSearch.vue?vue&type=script&lang=ts"
export * from "./QueuesStatisticsSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports